import React, { Suspense, useCallback } from 'react';
import './App.css';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './features/home/home';
import FrontDoor from './features/home/FrontDoor';
import Login from './features/account/login'; // Your login component
import WaitlistPage from './features/waitlist/WaitlistPage';
import PrivacyNotice from './features/waitlist/PrivacyNotice';
import VerifyPage from './features/account/VerifyPage';
import ActivatePage from './features/account/ActivatePage';
import Assets from './features/asset/assets'; // Your assets component
import AddAsset from './features/asset/addAsset'; // Your add asset component
import AssetDetail from './features/asset/assetDetail'; // Your asset detail component
// import PortfolioSnapshots from './features/portfolio/portfolioSnapshots';
// import AddSnapshot from './features/portfolio/addSnapshot';
// import PortfolioList from './features/portfolio/portfolioList';
// import AddPortfolio from './features/portfolio/addPortfolio';
// import PortfolioDetail from './features/portfolio/portfolioDetail';
// import PortfolioAssetList from './features/portfolio/portfolioAssetList';
// import AddHolding from './features/portfolio/addHolding';
// import EditHolding from './features/portfolio/editHolding';
import EditAsset from './features/asset/editAsset';
// import TransactionsList from './features/transaction/transactionsList';
// import CreateTransaction from './features/transaction/createTransaction';
import Markets from './features/markets/markets';
import MarketDetailPage from './features/markets/marketDetailPage';
import CotPage from './features/markets/cotPage';
import TagPage from './features/markets/tagPage';
import CustomEventsPage from './features/customEvents/customEventsPage';
import CustomEventBuilderPage from './features/customEvents/customEventBuilderPage';
import CustomEventConfigurationPage from './features/customEventSymbols/CustomEventConfigurationPage';
import StrategiesPage from './features/visualStrategies/strategiesPage';
import StrategyBuilderPage from './features/visualStrategies/strategyBuilderPage';
import TemplatesPage from './features/visualStrategies/templatesPage';
import StrategyConfigurationPage from './features/strategySymbols/StrategyConfigurationPage';
import BacktestsPage from './features/backtests/BacktestsPage';
import CreateBacktestPage from './features/backtests/CreateBacktestPage';
import BacktestResultsPage from './features/backtests/BacktestResultsPage';
import UserTradeSignalsPage from './features/userTradeSignals/UserTradeSignalsPage';
import PositionSizeCalculatorPage from './features/tools/PositionSizeCalculatorPage';
import TradesListPage from './features/trades/tradesListPage';
import CreateTradePage from './features/trades/createTradePage';
import TradeDetailPage from './features/trades/tradeDetailPage';
import ReviewTradePage from './features/trades/ReviewTradePage';
import TradeAnalyticsPage from './features/trades/tradeAnalyticsPage';
import CounterfactualPage from './features/trades/counterfactualPage';
import DecisionQualityPage from './features/trades/decisionQualityPage';
import TodayPage from './features/home/TodayPage';
import CycleScreenerPage from './features/markets/cycleScreenerPage';
import CycleClockPage from './features/markets/clock/CycleClockPage';
import AlertLogPage from './features/alerts/AlertLogPage';
import ExecutionsDemo from './features/trades/ExecutionsDemo';
import TradePlansPage from './features/tradePlans/TradePlansPage';
import TradePlanEditor from './features/tradePlans/TradePlanEditor';
import TradePlanViewer from './features/tradePlans/TradePlanViewer';
import UserSettingsPage from './features/userSettings/UserSettingsPage';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './config/auth';
import { IS_IDENTITY_BUILD } from './config/retailIdentity';
import IdentityGate from './auth/identity/IdentityGate';
import { useDispatch } from 'react-redux';
import { endSptSession } from './auth/identity/signOut';
import AdminPage from './features/admin/AdminPage';
import EventsPage from './features/events/EventsPage';
import ActivityFeedPage from './features/activityFeed/ActivityFeedPage';
import ProtectedRoute from './components/ProtectedRoute';
import AcademyHomePage from './features/academy/academyHomePage';
import AcademyLessonPage from './features/academy/academyLessonPage';
import FSMListPage from './features/fsm/FSMListPage';
import FSMBuilderPage from './features/fsm/FSMBuilderPage';
import DWLFLoader from './components/DWLFLoader';
const LoaderPreview = React.lazy(() => import('./features/dev/LoaderPreview'));

function App() {
  const dispatch = useDispatch();
  // The identity build's two sessions end together (IdentityGate).
  const onIdentitySessionEnded = useCallback(() => endSptSession(dispatch), [dispatch]);
  const app = (
        <Router>
          <Routes>
            {/* Front door without navbar (DWLF-145): signed-in users go on to Today */}
            <Route path="/" element={<FrontDoor />} />
            
            {/* Public, signed in or not (DWLF-584): retail is invite-only, so a visitor joins the waitlist */}
            <Route path="/waitlist" element={<WaitlistPage />} />
            <Route path="/privacy" element={<PrivacyNotice />} />

            {/* Activate page without navbar - token-based, no auth required */}
            <Route path="/activate" element={<ActivatePage />} />
            
            {/* All other routes with Layout/navbar */}
            <Route element={<Layout />}>
              <Route path="/old-home" element={<Home />} />
              <Route path="/login" element={<Login />} />
              {/* Sign-up is closed while the market-data licence forbids it: the waitlist takes its place. */}
              <Route path="/register" element={<Navigate to="/waitlist?from=sign_in" replace />} />
              <Route path="/verify" element={<VerifyPage />} />
              <Route path="/assets" element={<Assets />} />
              <Route path="/assets/add" element={<AddAsset />} />
              <Route path="/assets/:id" element={<AssetDetail />} />
              {/* <Route path="/portfolio-snapshots" element={<PortfolioSnapshots />} />
              <Route path="/portfolios/:id/snapshots/add" element={<AddSnapshot />} />
              <Route path="/portfolios" element={<PortfolioList />} />
              <Route path="/portfolios/:id" element={<PortfolioDetail />} />
              <Route path="/add-portfolio" element={<AddPortfolio />} />
              <Route path="/portfolios/:id/assets" element={<PortfolioAssetList />} />
              <Route path="/portfolios/:id/holdings/add" element={<AddHolding />} />
              <Route path="/portfolios/:id/holdings/:holdingId/edit" element={<EditHolding />} /> */}
              <Route path="/assets/:id/edit" element={<EditAsset />} />
              {/* <Route path="/portfolios/:id/transactions" element={<TransactionsList />} />
              <Route path="/portfolios/:id/transactions/add" element={<CreateTransaction />} /> */}
              <Route path="/markets" element={<CycleClockPage />} />
              <Route path="/markets/overview" element={<Markets />} />
              <Route path="/markets/cot" element={<CotPage />} />
              <Route path="/markets/:symbol" element={<MarketDetailPage />} />
              <Route path="/tags/:tag" element={<TagPage />} />
              <Route path="/my-signals" element={<UserTradeSignalsPage />} />
              <Route path="/signals/events" element={<EventsPage />} />
              <Route path="/activity" element={<ActivityFeedPage />} />
              <Route path="/activity-feed" element={<ActivityFeedPage />} />
              <Route path="/custom-events" element={<CustomEventsPage />} />
              <Route path="/custom-events/new" element={<CustomEventBuilderPage />} />
              <Route path="/custom-events/:eventId/edit" element={<CustomEventBuilderPage />} />
              <Route path="/custom-events/:eventId/view" element={<CustomEventBuilderPage />} />
              <Route path="/custom-events/:eventId/configure" element={<CustomEventConfigurationPage />} />
              <Route path="/strategies" element={<StrategiesPage />} />
              <Route path="/strategies/templates" element={<TemplatesPage />} />
              <Route path="/strategies/new" element={<StrategyBuilderPage />} />
              <Route path="/strategies/:strategyId/edit" element={<StrategyBuilderPage />} />
              <Route path="/strategies/:strategyId/view" element={<StrategyBuilderPage />} />
              <Route path="/strategies/:strategyId/configure" element={<StrategyConfigurationPage />} />
              <Route path="/state-machines" element={<FSMListPage />} />
              <Route path="/state-machines/new" element={<FSMBuilderPage />} />
              <Route path="/state-machines/:fsmId/edit" element={<FSMBuilderPage />} />
              <Route path="/state-machines/:fsmId/view" element={<FSMBuilderPage />} />
              <Route path="/backtests" element={<BacktestsPage />} />
              <Route path="/backtests/new" element={<CreateBacktestPage />} />
              <Route path="/backtests/:requestId/results" element={<BacktestResultsPage />} />
              <Route path="/tools/position-size" element={<PositionSizeCalculatorPage />} />
              <Route path="/trades" element={<TradesListPage />} />
              <Route path="/trades/new" element={<CreateTradePage />} />
              <Route path="/trades/analytics" element={<TradeAnalyticsPage />} />
              <Route path="/trades/counterfactual" element={<CounterfactualPage />} />
              <Route path="/trades/decisions" element={<DecisionQualityPage />} />
              <Route path="/today" element={<TodayPage />} />
              <Route path="/screener" element={<CycleScreenerPage />} />
              <Route path="/alerts/log" element={<AlertLogPage />} />
              <Route path="/trades/:tradeId/review" element={<ReviewTradePage />} />
              <Route path="/trades/:tradeId" element={<TradeDetailPage />} />
              <Route path="/executions-demo" element={<ExecutionsDemo />} />
              <Route path="/trade-plans" element={<TradePlansPage />} />
              <Route path="/trade-plans/new" element={<TradePlanEditor />} />
              <Route path="/trade-plans/:planId/edit" element={<TradePlanEditor />} />
              <Route path="/trade-plans/:planId/view" element={<TradePlanViewer />} />
              <Route path="/settings" element={<UserSettingsPage />} />
              <Route path="/admin" element={
                <ProtectedRoute permission={['admin:*', 'roles:write']}>
                  <AdminPage />
                </ProtectedRoute>
              } />
              <Route path="/learn" element={<AcademyHomePage />} />
              <Route path="/learn/:slug" element={<AcademyLessonPage />} />
              {process.env.NODE_ENV === 'development' && (
                <Route path="/dev/loader-preview" element={<Suspense fallback={<DWLFLoader size="large" />}><LoaderPreview /></Suspense>} />
              )}
            </Route>
          </Routes>
        </Router>
  );
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      {IS_IDENTITY_BUILD ? identityBuild(app, onIdentitySessionEnded) : app}
    </GoogleOAuthProvider>
  );
}

/**
 * The identity build: the waitlist and the privacy notice are for people who cannot sign in, so they
 * render without the gate; every other path is behind it.
 */
function identityBuild(app, onSessionEnded) {
  const publicPage = PUBLIC_PAGES[window.location.pathname.replace(/\/$/, '')];
  return publicPage ?? <IdentityGate onSessionEnded={onSessionEnded}>{app}</IdentityGate>;
}

const PUBLIC_PAGES = { '/waitlist': <WaitlistPage />, '/privacy': <PrivacyNotice /> };

export default App;
